import React from 'react';
import { Box, Typography, Stack, FormControl, Select, MenuItem, Pagination } from '@mui/material';

const TablePagination = ({ 
  pagination, 
  onPageChange, 
  onPageSizeChange, 
  isMobile = false 
}) => {
  if (!pagination || pagination.last_page <= 1) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mt: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
      >
        <Typography variant="body2" color="text.secondary">
          Showing{" "}
          {pagination.total === 0 ? 0 : (pagination.current_page - 1) * pagination.per_page + 1} to{" "}
          {Math.min(pagination.current_page * pagination.per_page, pagination.total)}{" "}
          of {pagination.total} entries
        </Typography>
        
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            Rows per page:
          </Typography>
          <FormControl size="small">
            <Select
              value={pagination.per_page}
              onChange={(e) => onPageSizeChange(e.target.value)}
              sx={{ minWidth: 70 }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>

      <Pagination
        count={pagination.last_page}
        page={pagination.current_page}
        onChange={(event, page) => onPageChange(page)}
        color="primary"
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 2}
        showFirstButton
        showLastButton
      />
    </Box>
  );
};

export default TablePagination;